import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import "ag-grid-charts-enterprise";
import { LicenseManager } from "@ag-grid-enterprise/core";
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

if (environment.production) {
  enableProdMode();
}

// Set the AG Grid license key
LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-067761}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Definio_Solutions}_is_granted_a_{Multiple_Applications}_Developer_License_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{24_September_2025}____[v3]_[0102]_MTc1ODY2ODQwMDAwMA==c7d7802f12faa78789f4e5b929adda31");

// Add charts to the app config providers
const enhancedAppConfig = {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    provideCharts(withDefaultRegisterables())
  ]
};

// Bootstrap with the enhanced MSAL configuration
bootstrapApplication(AppComponent, enhancedAppConfig)
  .catch(err => console.error('Error bootstrapping the application:', err));